// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import modalStyles from '../styles/ModalList.style';

const ModalList = ({ visible, onClose, children, modalHeaderText }) => {
  if (!visible) return null;

  return (
    <Modal
      fixedWidth
      isOpen={visible}
      headingAlign="center"
      heading={modalHeaderText}
      headingFontWeight="bold"
      onRequestClose={onClose}
      headingFontFamily="secondary"
      inheritedStyles={modalStyles}
      overlayClassName="TCPModal__Overlay"
      className={`TCPModal__Content shop-by-look-modal`}
      innerContentClassName={'shop-by-look-modal-inner-content'}
    >
      {children}
    </Modal>
  );
};

ModalList.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  modalHeaderText: PropTypes.string.isRequired,
};

export default ModalList;
